import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SeoService } from './../../shared';

@Component({
  selector: 'analytics-reporting',
  template: require('./analytics.component.html'),
  styles: [require('./analytics.component.scss'), require('.//../static.scss')]
})
export class AnalyticsComponent implements AfterViewInit {
  title = 'Analytics - Linescape';
  description = 'Global sailing schedules can provide a wealth of analytical data to give you deeper insights into the trends affecting your business, for better decision making';

  constructor(private route: ActivatedRoute, private seo: SeoService) {
    // Do stuff
  }

  ngAfterViewInit() {
    this.seo.set(this.title, this.description);
    this.route.params.subscribe(params => {
      if (params['scroll'] != null && params['scroll'] === 'true') {
        window.scrollTo(0, 0);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/static/analytics/analytics.component.ts